import BackDrop from 'components/BackDrop';
import { createContext, useContext, useState, useEffect } from 'react';
import { getUserInfo } from 'requests';
import sleep from 'utils/sleep';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCompanyStatus } from 'requests/paymentStatus';

export const NapCobranzas = createContext();
export const useNapBus = () => useContext(NapCobranzas);

const exclude = ['/home', '/login', '/forgot-password'];

const NapCobranzasProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // DATA CONTEXT
  const [userInfo, setUserInfo] = useState({});
  const [company, setCompany] = useState({});

  const [infoPayment, setInfoPayment] = useState(null);

  const redirectTo = async () => {
    await sleep(200);
    navigate('/login');
  };

  const getData = async () => {
    try {
      setLoading(true);
      const res = await getUserInfo();

      if (res.message) {
        setUserInfo(res.data);

        const temp = await getCompanyStatus(res.data.roles);
        setInfoPayment(temp);
      } else {
        await redirectTo();
      }
    } catch (error) {
      await redirectTo();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!loading && userInfo && userInfo.active === false) {
      console.warn('Usuario inactivo, cerrando sesión...');
      localStorage.removeItem('token');
      navigate('/login');
    }
  }, [userInfo, loading, location.pathname]);

  useEffect(() => {
    if (!exclude.includes(location.pathname)) getData();
    else setLoading(false);
  }, []);

  const isSuperAdmin = userInfo?.roles?.includes('superadmin');
  const isAdmin = ['admin', 'superadmin', 'owner'].some((role) => userInfo?.roles?.includes(role));

  const isCaja = userInfo?.roles?.length === 1 && userInfo.roles.includes('caja');

  return (
    <NapCobranzas.Provider value={{ userInfo, company, setCompany, infoPayment, isSuperAdmin, isAdmin, isCaja }}>
      {children}
      <BackDrop loading={loading} />
    </NapCobranzas.Provider>
  );
};
export default NapCobranzasProvider;
